import React__default from 'react';
import { AccordionItem } from '@grandvisionhq/common';

const AccordionCardItem = ({ children , title , id ,  })=>{
    return /*#__PURE__*/ React__default.createElement(AccordionItem, {
        variant: "narrow",
        label: title,
        id: id || title
    }, children);
};
const AccordionSection = ({ children  })=>{
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ React__default.isValidElement(child) || child.type !== AccordionCardItem) {
            console.error('AccordionSection only accepts LineItemCard.AccordionCardItem as children');
            return null;
        }
        if (child) {
            return /*#__PURE__*/ React__default.createElement(AccordionItem, {
                variant: "narrow",
                label: child.props.title,
                id: `${child.props.title}-${index}`,
                expanded: child.props.expanded
            }, child.props.children);
        }
        return null;
    }));
};

export { AccordionCardItem, AccordionSection };
//# sourceMappingURL=AccordionSection.js.map
